import React from 'react';

import classes from './AutoSuggestBox.scss';
import AutoSuggestList from './AutoSuggestList/AutoSuggestList';

const autoSuggestBox = (props) => {

    return (
        <div style={{ display: props.toggleAutoSuggest ? 'block' : 'none' }} className={`${classes.Container} u-relative u-backgroundColorWhite`}>
        { props.airportData ? <AutoSuggestList 
            airportDataUpdated={props.airportData.airports} 
            selectCity={props.selectCity}
            type={props.type}
            activeItem={props.activeItem}
            hoverInHandler={props.hoverInHandler}
            hoverOutHandler={props.hoverOutHandler}
            /> : props.hotelsData ? 
            <React.Fragment>
                {
                    props.hotelsData.length > 0 ?
                    <React.Fragment>
                        <AutoSuggestList 
                            hotelsDataUpdated={props.hotelsData} 
                            selectCity={props.selectCity}
                            activeItem={props.activeItem}
                            hoverInHandler={props.hoverInHandler}
                            hoverOutHandler={props.hoverOutHandler}
                        />
                    </React.Fragment> : null
                }
            </React.Fragment> : <p style={{paddingLeft: '4rem'}}>No search results</p> }
        </div>
    );
}

export default autoSuggestBox;


// WEBPACK FOOTER //
// ./src/components/UI/AutoSuggestBox/AutoSuggestBox.js